import React from "react";
import { Text, Flex, type FlexProps } from "@chakra-ui/react";
import { ChevronRightIcon } from "ui/icons";

function Value({ amount, unit }: { amount: string; unit: string }) {
  return (
    <Flex
      bg="rgba(255, 255, 255, 0.15)"
      borderRadius="smallest"
      color="brand.text.dark"
      textStyle="caption1"
      gap="tinier"
      px="tiny"
    >
      <Text as="span" fontWeight="bold">
        {amount}
      </Text>
      <Text as="span">{unit}</Text>
    </Flex>
  );
}

export function Tooltip({ children, ...props }: FlexProps) {
  return (
    <Flex
      bg="brand.background.dark"
      borderRadius="smallest"
      boxShadow="md"
      color="brand.text.dark"
      gap="smallest"
      p={2}
      pos="relative"
      {...props}
    >
      <Flex bg="brand.accent.primary" borderRadius="smallest" w="4px" />

      <Flex align="start" direction="column" gap="smallest" width="max-content">
        <Text textStyle="headline3" fontSize={{ base: "brand.sm", md: "brand.md" }} fontWeight="semibold">
          Drop off
        </Text>

        <Flex align="start" flexDir="column" gap="tinier">
          <Value amount="68%" unit="drop off" />
          <Value amount="200" unit="unique customers" />
        </Flex>

        <Text
          id="funnels-tooltip-link"
          color="brand.textSecondary.dark"
          textStyle="caption1"
          lineHeight="normal"
          display="flex"
          alignItems="center"
          pos="relative"
        >
          Sync audience
          <ChevronRightIcon id="funnels-tooltip-chevron" boxSize="icon.sm" mt="2px" />
        </Text>
      </Flex>
    </Flex>
  );
}
